import React from "react";

const InputHour = (props)=>{
    return(
        <input 
            type="text" 
            id={props.id} 
            name={props.id}
            data-inputmask-alias="datetime" 
            data-inputmask-inputformat="HH:MM"  
            data-inputmask-placeholder="-" 
            value={props.value} 
            onChange={(e)=>props.handleChange(e, props.variables)} 
            onBlur={(e)=>props.handleChange(e, props.variables)}
            disabled={props.disabled}
            className={"form-control" +props.class}
        />
    )
}

export default InputHour;

InputHour.defaultProps = {
    variables:'',
    class:''
};